<div *ngIf="showNowPublishedMessage" class="p-d-flex p-jc-center p-mb-4">
    <p-message severity="info" text="This note has been published"></p-message>
</div>
<lb-loading-indicator *ngIf="isLoadingTemplate || !serviceIsReady" [label]="isLoadingTemplate ? 'Loading Template' : 'Loading Note Entry'"></lb-loading-indicator>

<div class="p-grid p-nogutter note-entry-container" [ngClass]="viewIsNarrow ? 'mobile' : 'desktop'" [hidden]="accessRevokedVisible || isLoadingTemplate || !serviceIsReady">

    <!--    Select Template-->
    <ng-container *ngIf="!enteringNote">
        <div class="p-col-12 p-d-flex p-jc-center">
            <ng-container *ngTemplateOutlet="selectTemplate"></ng-container>
        </div>
    </ng-container>

    <!--DESKTOP-->
    <ng-container *ngIf="!viewIsNarrow && !isLoadingTemplate && enteringNote">
        <div class="p-col-4 toc-container">
            <p-card styleClass="log-card sticky-container">
                <ng-container *ngTemplateOutlet="navigatorTemplate"></ng-container>
            </p-card>
            <ng-container *ngTemplateOutlet="tocTemplate"></ng-container>
        </div>
        <div class="p-col-5 entry-container">
            <ng-container *ngTemplateOutlet="noteEntryTemplate"></ng-container>
        </div>
        <div class="p-col-3 controls-container">
            <ng-container *ngTemplateOutlet="noteControlsTemplate"></ng-container>
        </div>
    </ng-container>


    <!--MOBILE-->
    <ng-container *ngIf="viewIsNarrow && !isLoadingTemplate && enteringNote">

        <div class="p-col-12">
            <p-card styleClass="log-card sticky-container">
                <ng-container *ngTemplateOutlet="navigatorTemplate"></ng-container>
            </p-card>
        </div>

        <div class="p-col-12 toc-container" *ngIf="mode === TocModes.TOC">
            <ng-container *ngTemplateOutlet="tocTemplate"></ng-container>
        </div>

        <ng-container *ngIf="mode === TocModes.EDITOR">
            <div class="p-col-12 controls-container">
                <ng-container *ngTemplateOutlet="noteControlsTemplate"></ng-container>
            </div>
            <div class="p-col-12 entry-container">
                <ng-container *ngTemplateOutlet="noteEntryTemplate"></ng-container>
            </div>
        </ng-container>
    </ng-container>

</div>

<ng-template #noteControlsTemplate>
    <div class="sticky-container">
        <lb-note-entry-controls></lb-note-entry-controls>
        <div *ngIf="editingPublishedNote || syncErrorFeedback || statusMessage" class="p-grid">
            <div [ngClass]="viewIsNarrow ? 'p-col-12' : 'p-col-10'">
                <div class="p-mb-1">
                    <ng-container *ngIf="syncErrorFeedback; else statusMessage">
                        <p-message (click)="showErrorFeedback($event)" class="update-info" severity="warn" [text]="syncErrorFeedback.message"></p-message>
                    </ng-container>
                </div>
                <ng-container *ngIf="editingPublishedNote"
                              [ngTemplateOutlet]="saveButton"
                              [ngTemplateOutletContext]="{ $implicit: true }">
                </ng-container>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #noteEntryTemplate>
    <div class="p-grid note-entry-grid">
        <ng-container *ngIf="selectedNode || (selectedTemplate && selectedTemplate.isDefaultTemplate) else noteEntryTemplateInfoTemplate">
            <div *ngIf="selectedTemplate && !selectedTemplate.isDefaultTemplate" class="p-col-12 p-pt-0 sticky-container">
                <p-card styleClass="controls-card">
                    <div class="p-d-flex p-ai-center flex-container-center">
                        <div *ngIf="templateType === TemplateTypes.INSPECTION">
                            <button pButton icon="pi pi-arrow-left" class="p-button-secondary"
                                    [disabled]="!hasPreviousSection"
                                    (click)="changeGroup('PREVIOUS')">
                            </button>
                        </div>
                        <div class="p-text-bold p-text-center p-px-3">
                            {{editorMode === EditorModes.EDITING ? displayName : 'Reviewing Note'}}
                        </div>
                        <div *ngIf="templateType === TemplateTypes.INSPECTION" class="p-text-right">
                            <button pButton icon="pi pi-arrow-right"
                                    class="p-button-secondary"
                                    [disabled]="!hasNextSection"
                                    (click)="changeGroup('NEXT')">
                            </button>
                        </div>
                    </div>
                </p-card>
            </div>
            <div class="p-col-12 p-px-3 p-pt-0">
                <lb-note-entry [(mode)]="editorMode"></lb-note-entry>
                <div class="p-grid p-nogutter p-pt-2">
                    <div class="p-col-6">
                        <button *ngIf="templateType === TemplateTypes.INSPECTION"
                                tabindex="-1"
                                pButton class="p-d-md-none p-shadow-6"
                                icon="pi pi-compass" (click)="showSections = true">
                        </button>
                    </div>
                    <div class="p-col-6 p-text-right">
                        <ng-container *ngTemplateOutlet="publishButton; context: { $implicit: true }"></ng-container>
                        <button *ngIf="templateType === TemplateTypes.INSPECTION && hasNextSection && !isReviewing"
                                pButton pRipple class="p-shadow-6" label="Next" icon="pi pi-arrow-right" iconPos="right"
                                (click)="changeGroup('NEXT')">
                        </button>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-template #noteEntryTemplateInfoTemplate>
            <div class="p-col-12 p-text-center">
                <p-message severity="info" text="Select a {{templateType === TemplateTypes.INSPECTION ? 'section' : 'sub template'}} from the side to begin"></p-message>
            </div>
        </ng-template>
    </div>
</ng-template>

<ng-template #selectTemplate>
    <p-card styleClass="log-card">
            <div *ngIf="allowMultiLog" class="p-mb-1">
                <select id="select-log" title="Log selection"
						[disabled]="isLoadingTemplate"
                        [ngModel]="selectedLog$ | async" (ngModelChange)="selectedLog = $event">
                    <option selected disabled hidden [ngValue]="undefined">Select Log</option>
                    <option *ngFor="let log of logs" [ngValue]="log">{{log.name}}</option>
                </select>
            </div>
            <div>
                <select id="select-template" title="Template selection"
                        [disabled]="!selectedLog || isLoadingTemplate"
                        [ngModel]="selectedTemplate$ | async" (ngModelChange)="selectedTemplate = $event">
                    <option selected disabled hidden [ngValue]="undefined"> {{!serviceIsReady ? 'Loading Templates' : 'Select Template'}}</option>
                    <option *ngFor="let template of templates" [ngValue]="template">{{template.name}}</option>
                </select>
            </div>

    </p-card>
</ng-template>

<ng-template #navigatorTemplate>
    <div class="p-d-flex p-ai-center flex-container-center">
        <p-button icon="pi pi-arrow-left" label="Back" styleClass="p-button-secondary" (onClick)="goBack()"></p-button>
        <label class="whitespace-pre-line p-text-center p-mx-2">
            {{displayPath}}
        </label>
        <div>&nbsp;</div>
    </div>
</ng-template>

<ng-template #tocTemplate>
    <div class="toc-container" style="overflow: auto">
        <p-treeTable #toc
                     [value]="noteEntryService.treeNodeMap.nodes"
                     scrollHeight="30vh"
                     styleClass="p-treetable-sm">
            <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                <tr *ngIf="!restrictSection || restrictSection && restrictSection === rowNode.node.data.id" class="toc-node-{{rowNode.node.data.id}} clickable"
                    [ngClass]="{'p-highlight': selectedNodeId === rowNode.node.data.id && !isReviewing}"
                    [ttRow]="rowNode" (click)="setSelectedNode(rowNode.node)">
                    <td [colSpan]="templateType === TemplateTypes.INSPECTION ? 1 : 2">
                        <div class="p-d-flex p-ai-center">
                            <div>
                                <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                            </div>
                            <div>
                                {{rowData.name}}
                            </div>
                        </div>
                    </td>
                    <td *ngIf="templateType === TemplateTypes.INSPECTION">
                        <span class="status-square p-d-block p-ml-auto" [ngClass]="rowData.color.toString()"></span>
                    </td>
                </tr>
            </ng-template>
        </p-treeTable>
        <div *ngIf="templateType === TemplateTypes.INSPECTION" class="p-text-center p-my-1">
            <button *ngIf="!editingPublishedNote"
                    pButton class="p-button p-button-outlined p-button-rounded w-100"
                    (click)="reviewNote()"
                    [disabled]="!canReviewNote"
                    label="Review">
            </button>
        </div>
    </div>
</ng-template>

<ng-template #saveButton let-showDialog>
	<ng-container *ngIf="editingPublishedNote">
		<button pButton class="p-button-success w-100"
				[disabled]="!publishEnabled"
				(click)="publishNote(!!showDialog)"
				label="Save Changes"></button>
	</ng-container>
</ng-template>

<ng-template #publishButton let-showDialog>
	<button *ngIf="(templateType === TemplateTypes.OPERATIONAL || isReviewing) && !editingPublishedNote"
			pButton pRipple class="p-shadow-6 p-button-success"
			[disabled]="!publishEnabled"
			[label]="(templateType === TemplateTypes.OPERATIONAL ? 'Add' : 'Publish')"
			(click)="publishNote(!!showDialog)">
	</button>
</ng-template>

<ng-template #statusMessage>
    <p-message class="update-info" *ngIf="hasPendingChanges" severity="info" text="Changes pending"></p-message>
    <p-message class="update-info" *ngIf="!hasPendingChanges && templateType === TemplateTypes.INSPECTION && !editingPublishedNote && ((noteEntryService.editingNote && noteEntryService.syncDate) || noteEntryService.isSyncingNote)"
               severity="info"
               [text]="noteEntryService.isSyncingNote ? 'Saving Note' : ('Saved ' + (noteEntryService.syncDate | date: 'HH:mm:ss'))">
    </p-message>
    <button *ngIf="!editingPublishedNote && noteEntryService.editingNote?.id && templateType === TemplateTypes.INSPECTION"
            pButton class="p-button-danger w-100 p-mt-1" icon="pi pi-trash" label="Delete" (click)="deleteNote($event)">
    </button>
</ng-template>

<p-dialog header="Sections"
          appendTo="body"
          [(visible)]="showSections"
          [modal]="true"
          [focusTrap]="true"
          [draggable]="false"
          [resizable]="false"
          [style]="{ width: '750px' }">
    <ng-container *ngTemplateOutlet="tocTemplate"></ng-container>
</p-dialog>

<p-dialog header="Note Review"
          appendTo="body"
          [style]="{width: '750px'}"
          [modal]="true"
          [draggable]="false"
          [dismissableMask]="true"
          [resizable]="false"
          position="top"
          [(visible)]="showFieldsMissing">

    <ng-container *ngIf="templateType === TemplateTypes.INSPECTION">
        <p-table *ngIf="issueNodes.missingValues.length"
                 selectionMode="single"
                 styleClass="p-datatable-sm"
                 [value]="issueNodes.missingValues">
            <ng-template pTemplate="caption">
                The following sections have required fields
            </ng-template>
            <ng-template pTemplate="body" let-node>
                <tr class="clickable" (click)="setSelectedNode(node); showFieldsMissing = false;">
                    <td>{{node.data.name}}</td>
                    <td><span class="status-square p-d-block p-ml-auto" [ngClass]="node.data.color.toString()"></span></td>
                </tr>
            </ng-template>
        </p-table>
        <p-table *ngIf="issueNodes.abnormalValues.length"
                 selectionMode="single"
                 styleClass="p-datatable-sm"
                 [value]="issueNodes.abnormalValues">
            <ng-template pTemplate="caption">
                The following sections have abnormal values
            </ng-template>
            <ng-template pTemplate="body" let-node>
                <tr class="clickable" (click)="setSelectedNode(node); showFieldsMissing = false;">
                    <td>{{node.data.name}}</td>
                    <td><span class="status-square p-d-block p-ml-auto" [ngClass]="node.data.color.toString()"></span></td>
                </tr>
            </ng-template>
        </p-table>
    </ng-container>

    <ng-container *ngIf="templateType === TemplateTypes.OPERATIONAL">
        <div class="p-d-flex p-ai-center p-jc-center">
            <p-message *ngIf="issueNodes.missingValues.length"
                       severity="error" text="Required fields are not completed">
            </p-message>
            <p-message *ngIf="issueNodes.abnormalValues.length"
                       severity="warn" text="Fields have abnormal values">
            </p-message>
        </div>
    </ng-container>

    <ng-template pTemplate="footer">
		<ng-container *ngTemplateOutlet="publishAllowed ? editingPublishedNote ? saveButton : publishButton : null; context: { $implicit: false }"></ng-container>
        <button *ngIf="!publishAllowed" pButton class="p-button-secondary" label="Dismiss" (click)="showFieldsMissing = false"></button>
    </ng-template>
</p-dialog>
<p-confirmDialog appendTo="body" class="navigation-dialog" [style]="{width: '750px'}" [key]="navigationGuardKey" [closable]="false" (onHide)="displayingNavModal = false" rejectButtonStyleClass="p-button-secondary" defaultFocus="reject"></p-confirmDialog>

<p-dialog appendTo="body" header="Note Sync Feedback" [style]="{width: '750px'}" [modal]="true" [draggable]="false" [(visible)]="syncFeedbackVisible">
    <div>
        <code [style]="{whiteSpace: 'pre-wrap'}">
            {{syncObjectJSON}}
        </code>
    </div>
</p-dialog>

<p-dialog appendTo="body" [visible]="accessRevokedVisible" [modal]="true" [draggable]="false" [resizable]="false" [closable]="false">
    You have been removed as a co-creator of this note.
    <ng-template pTemplate="footer">
        <button pButton label="Close" (click)="accessRevokeAcknowledged()"></button>
    </ng-template>
</p-dialog>
<p-confirmPopup></p-confirmPopup>